import * as LabelPrimitive from '@radix-ui/react-label'
import React from 'react'

import { cn } from '@/lib/cn'

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-system-text-primary font-medium text-base',
      className,
    )}
    {...props}
  />
))

Label.displayName = LabelPrimitive.Root.displayName

export { Label }
